import React from "react";
import InheritenceDisplay from "components/InheritenceDisplay";
import { useFormikContext } from "formik";
import { STATE_KEYS } from "utils/constants/state";
import classnames from "classnames";

const ShippingDestinationsSummary = ({ selections, error }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <InheritenceDisplay
      title="Shipping destinations"
      error={error}
      onRemove={() => {
        setFieldValue(STATE_KEYS.SHORT_LINK.SHIPPING_WORLDWIDE, false);
        setFieldValue(
          `${STATE_KEYS.SHORT_LINK.SHIPPING_ADDRESS_COLLECTION}.allowed_countries`,
          []
        );
      }}
    >
      <ul className="ma0 pa0 list w-100 pt2">
        {selections && selections.length ? (
          selections.map((selection, selectionIx) => {
            return (
              <li
                key={selection.id}
                className={classnames(
                  "flex flex-row justify-between items-center",
                  {
                    pt3: selectionIx
                  }
                )}
              >
                <div className="f6 fw5">{selection.name}</div>
                <div className="f6 pr1">{selection.id}</div>
              </li>
            );
          })
        ) : (
          <li className="flex flex-row justify-between items-center">
            <div className="f6 fw5">No destinations</div>
          </li>
        )}
      </ul>
    </InheritenceDisplay>
  );
};

export default ShippingDestinationsSummary;
